{
  "permissions": {
    "noPermission": "Sie sind nicht berechtigt, diese Aktion auszuführen",
    "viewOnly": "Nur anzeigen"
  },
  "importFinished": "Der Import wurde abgeschlossen",
  "switchLevel": "Stufe wechseln",
  "removeFilter": "Filter entfernen",
  "styleByProperty": "Legen Sie die Modellabmessungen mithilfe der Eigenschaftswerte der Listenelemente fest",
  "styleByPropertyTooltip": "Wenn diese Option aktiviert ist, wird die Größe der Modelle in dieser Ebene anhand der Abmessungen aus Ihrer Listenelementtabelle bestimmt. Ihre Listenelemente müssen zusätzliche numerische Spalten für „Breite“, „Länge“ und „Höhe“ enthalten, um diese Option verwenden zu können. Eine ausführliche Anleitung finden Sie in unserer",
  "styleByPropertyTooltipLink": "Artikel in der Wissensdatenbank",
  "copy": {
    "copyTo": "An diesen Ort kopieren",
    "setTo": "Neuen Standort festlegen",
    "tooltip": {
      "Map": "Kann nicht in einen Plan kopiert werden",
      "Layer": "Kann nicht in eine Ebene kopiert werden"
    }
  },
  "digitalTwin": {
    "cameraModes": {
      "orbit": "Kamera umkreisen",
      "walk": "Gehen Sie durch",
      "fly": "Fly Kamera"
    }
  },
  "venue_bookmark": "Lesezeichen für den Veranstaltungsort",
  "venue_bookmark_form": {
    "save": "Lesezeichen speichern",
    "name": "Name"
  },
  "venue_bookmark_view": {
    "bookmarks": "Lesezeichen",
    "delete_bookmark": "Lesezeichen löschen",
    "create_bookmark": "Lesezeichen aus der aktuellen Ansicht erstellen",
    "no_bookmarks": "Keine Lesezeichen"
  },
  "venue_bookmark_no_venue_error": {
    "title": "Das Lesezeichen konnte nicht erstellt werden",
    "message": "Sie können kein Lesezeichen außerhalb eines Veranstaltungsortes erstellen"
  },
  "venue_bookmark_creation_error": {
    "title": "Das Lesezeichen kann nicht erstellt werden",
    "message": "Beim Erstellen des Lesezeichens ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut."
  },
  "controls": {
    "toggle_street_names": "Straßen- und Ortsnamen",
    "disabled_terrain_sitemap_3d": "Terrain kann nicht aktiviert werden, wenn eine 3D-Sitemap angezeigt wird",
    "disabled_3d_buildings_sitemap_3d": "3D-Gebäude können nicht aktiviert werden, wenn eine 3D-Sitemap angezeigt wird"
  },
  "modelPreview": {
    "front_view": "Vorderansicht",
    "front_left_view": "Ansicht von vorne links",
    "capture_thumbnail": "Vorschaubild aufnehmen",
    "preview_info_heading": "Prüfen Sie die Vorschau und passen Sie das Modell bei Bedarf an. Achten Sie dabei auf Folgendes:",
    "preview_info_model_appears": "Das Modell erscheint wie erwartet in der Vorschau",
    "preview_info_centered": "Die Mitte des Modells schneidet sich mit der blauen Linie",
    "preview_info_orientation": "Das Modell ist korrekt ausgerichtet und zeigt bei Betrachtung von vorne nach vorne",
    "model_not_supported_error": "Das Modell wird nicht unterstützt. Versuchen Sie es mit einer anderen Datei oder wenden Sie sich an den Support."
  },
  "modelShowThumbnailUploader": "oder laden Sie eine Datei hoch",
  "not_support_custom_colour": "Das Modell, das Sie hochgeladen haben, unterstützt keine benutzerdefinierten Farben. Um zu erfahren, wie Sie dies aktivieren können, lesen Sie den Artikel ",
  "areaModel": {
    "distribution": {
      "title": "Verteilung",
      "random": "Zufällig",
      "uniform": "Uniform"
    },
    "rotation": {
      "title": "Drehung",
      "random": "Zufällig",
      "uniform": "Uniform"
    }
  },
  "systemDataFieldNames": {
    "MapObjectName": "Objektname zuordnen",
    "MapObjectArea": "Gebiet",
    "MapObjectLength": "Länge",
    "Coordinates": "Koordinaten",
    "RouteTime": "Zeit der Route",
    "QuantityOfModelsOnLine": "Menge",
    "QuantityOfModelsInArea": "Menge",
    "RotationZOfModelsInArea": "Drehung",
    "IconRotation": "Drehung",
    "ModelAltitude": "Höhe"
  },
  "dateTimeFilter": {
    "newObjectFilteredTitle": "Gefiltertes Kartenobjekt",
    "newObjectFilteredBody": "Das neu erstellte Kartenobjekt wurde nach dem Datums- und Uhrzeitfilter gefiltert"
  },
  "sitemapVersion": {
    "twoDimensional": "2D",
    "threeDimensional": "3D"
  },
  "shareMap": {
    "copyNotification": "Der Link zur geteilten Karte wurde in Ihre Zwischenablage kopiert",
    "useDescription": "Geteilte Links sind nur für den privaten Gebrauch mit bestimmten Personen vorgesehen.",
    "warning": "Öffentliche Veröffentlichungen oder Massenverbreitungen (z. B. auf Websites, sozialen Medien oder Mailinglisten) sind nicht gestattet. Um mehr darüber zu erfahren, wie du Pläne öffentlich teilen kannst, wende dich bitte an support@iventis.com.",
    "customSharedLinkDuration": {
      "description": "Dauer des Links festlegen:",
      "duration": {
        "ThreeDays": "3 Tage",
        "SevenDays": "7 Tage",
        "FourteenDays": "14 Tage",
        "ThirtyDays": "30 Tage"
      },
      "contactSupport": "Wenn Sie den Zugriff für mehr als 30 Tage gewähren müssen, wenden Sie sich bitte an support@iventis.com, um Ihre Anforderungen zu besprechen."
    }
  },
  "screenshot": {
    "take_screenshot": "Machen Sie einen Screenshot",
    "screenshot": "Bildschirmfoto",
    "copiedToClipboardToast": {
      "title": "Screenshot in die Zwischenablage kopiert",
      "message": "Sie können es jetzt in eine andere Anwendung einfügen"
    },
    "downloadedImageToast": {
      "title": "Screenshot heruntergeladen",
      "message": "Sie finden ihn in Ihrem Download-Ordner"
    },
    "errorToast": {
      "title": "Etwas ist schief gelaufen",
      "message": "Screenshot konnte nicht aufgenommen werden. Bitte versuchen Sie es erneut"
    }
  },
  "style": {
    "altitude": "Höhe"
  }
}